(function () {
  'use strict';

  var GLOBAL_KEY = '__GLG_SPATIAL_ENTRY_RUNTIME_V2__';
  if (window[GLOBAL_KEY]) {
    if (typeof window[GLOBAL_KEY].boot === 'function') window[GLOBAL_KEY].boot(document);
    return;
  }

  var STATE_PATHS = Object.freeze({
    ready_to_review: 'evidence_pack_review',
    needs_evidence: 'complete_evidence',
    site_check_likely: 'site_evidence',
    professional_scope: 'professional_scope_review',
  });

  var PROFESSIONAL_STATES = Object.freeze({
    ready_to_review: true,
    needs_evidence: false,
    site_check_likely: true,
    professional_scope: true,
  });

  var UAV_RESULT_STORAGE_KEY = 'gcity_uav_precheck_results_v1';
  var UAV_HANDOFF_STORAGE_KEY = 'gcity_uav_precheck_handoff_v1';
  var UAV_RESULT_LIMIT = 12;

  function getCopy(root) {
    var node =
      root && root.querySelector ? root.querySelector('[data-spatial-precheck-copy]') : null;

    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function getEvidenceLabels(form) {
    var labels = {};

    Array.prototype.slice
      .call(form.querySelectorAll('[data-gse-evidence-key]'))
      .forEach(function (control) {
        var key = clean(control.getAttribute('data-gse-evidence-key'));
        var row = control.closest('.gse-evidence-row');
        var label = row && row.querySelector('strong');
        if (key && label) labels[key] = clean(label.textContent);
      });

    return labels;
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function getWizardRoot(form) {
    return form && form.closest('[data-spatial-survey-precheck]');
  }

  function setWizardStep(form, step, focusStep) {
    if (!form || !form.matches('[data-gse-uav-wizard]')) return;

    var panelSteps = Array.prototype.slice
      .call(form.querySelectorAll('[data-gse-wizard-panel]'))
      .map(function (panel) {
        return Number(panel.getAttribute('data-gse-wizard-panel')) || 1;
      });
    var maxStep = panelSteps.length ? Math.max.apply(Math, panelSteps) : 1;
    var nextStep = Math.max(1, Math.min(maxStep, Number(step) || 1));
    form.dataset.gseWizardStep = String(nextStep);

    Array.prototype.slice
      .call(form.querySelectorAll('[data-gse-wizard-panel]'))
      .forEach(function (panel) {
        var panelStep = Number(panel.getAttribute('data-gse-wizard-panel'));
        panel.hidden = panelStep !== nextStep;
      });

    var root = getWizardRoot(form);
    if (root) {
      Array.prototype.slice
        .call(root.querySelectorAll('[data-gse-step-indicator]'))
        .forEach(function (item) {
          var itemStep = Number(item.getAttribute('data-gse-step-indicator'));
          item.setAttribute(
            'data-state',
            itemStep < nextStep ? 'complete' : itemStep === nextStep ? 'current' : 'upcoming'
          );
        });
    }

    if (focusStep === false) return;

    var activePanel = form.querySelector('[data-gse-wizard-panel="' + nextStep + '"]');
    if (!activePanel) return;

    var focusable =
      activePanel.querySelector('input:checked') ||
      activePanel.querySelector('input, select, textarea, button');
    if (focusable && typeof focusable.focus === 'function') {
      window.requestAnimationFrame(function () {
        focusable.focus({ preventScroll: true });
      });
    }
  }

  function validateWizardStep(form, step) {
    var panel = form.querySelector('[data-gse-wizard-panel="' + step + '"]');
    if (!panel) return true;

    var required = Array.prototype.slice.call(panel.querySelectorAll('[required]'));
    for (var index = 0; index < required.length; index += 1) {
      if (!required[index].checkValidity()) {
        required[index].reportValidity();
        return false;
      }
    }
    return true;
  }

  function bindWizard(root, form) {
    if (!root || !form || !form.matches('[data-gse-uav-wizard]')) return;
    if (form.dataset.gseWizardReady === 'true') return;
    form.dataset.gseWizardReady = 'true';

    form.addEventListener('click', function (event) {
      var next = event.target.closest('[data-gse-wizard-next]');
      var back = event.target.closest('[data-gse-wizard-back]');
      var current = Number(form.dataset.gseWizardStep || '1');

      if (next) {
        event.preventDefault();
        if (!validateWizardStep(form, current)) return;
        setWizardStep(form, current + 1);
        return;
      }

      if (back) {
        event.preventDefault();
        setWizardStep(form, current - 1);
      }
    });

    form.addEventListener('change', function (event) {
      if (Number(form.dataset.gseWizardStep || '1') !== 2) return;
      if (!event.target || event.target.type !== 'radio') return;

      var evidence = getEvidence(form);
      var values = Object.keys(evidence).map(function (key) {
        return evidence[key];
      });
      if (
        !values.length ||
        values.some(function (value) {
          return !value;
        })
      )
        return;

      reviewAndRender(root, form);
    });

    setWizardStep(form, Number(form.dataset.gseWizardStep || '1'), false);
  }

  function getPurpose(form) {
    var checked = form.querySelector('input[name="purpose"]:checked');
    return checked ? clean(checked.value) : '';
  }

  function getEvidence(form) {
    var evidence = {};
    Array.prototype.slice
      .call(form.querySelectorAll('[data-gse-evidence-key]'))
      .forEach(function (control) {
        var key = clean(control.getAttribute('data-gse-evidence-key'));
        if (!key) return;

        if (control.matches('select, input, textarea')) {
          evidence[key] = clean(control.value);
          return;
        }

        var checked = control.querySelector('input[type="radio"]:checked');
        evidence[key] = checked ? clean(checked.value) : '';
      });
    return evidence;
  }

  function keysByState(evidence, state) {
    return Object.keys(evidence).filter(function (key) {
      return evidence[key] === state;
    });
  }

  function uavReadiness(form) {
    var purpose = getPurpose(form);
    var evidence = getEvidence(form);
    var keys = Object.keys(evidence);
    var scoreTotal = keys.reduce(function (total, key) {
      if (evidence[key] === 'have') return total + 100;
      if (evidence[key] === 'unsure') return total + 50;
      return total;
    }, 0);
    var score = keys.length ? Math.round(scoreTotal / keys.length) : 0;
    var available = keysByState(evidence, 'have');
    var uncertain = keysByState(evidence, 'unsure');
    var missing = keysByState(evidence, 'missing');
    var state = score >= 85 ? 'ready_to_review' : 'needs_evidence';
    var recommendations = missing.concat(uncertain);

    return {
      state: state,
      purpose: purpose,
      siteType: '',
      evidence: evidence,
      score: score,
      recommendations: recommendations,
      available: available,
      uncertain: uncertain,
      missing: missing,
      recommendedPath: score >= 85 ? 'professional_scope_review' : 'complete_evidence',
    };
  }

  function readiness(form) {
    if (form && form.matches('[data-gse-uav-wizard]')) return uavReadiness(form);
    var purpose = getPurpose(form);
    var siteType = clean(form.elements.site_type && form.elements.site_type.value);
    var evidence = getEvidence(form);
    var available = keysByState(evidence, 'have');
    var uncertain = keysByState(evidence, 'unsure');
    var missing = keysByState(evidence, 'missing');
    var formalPurpose = purpose === 'redevelopment_application';
    var complexSite = siteType === 'land' || siteType === 'water';
    var siteConditionPurpose = purpose === 'condition_record';
    var sitePhotosReady = evidence.site_photos === 'have';
    var criticalEvidenceGap =
      evidence.plans_drawings === 'missing' || evidence.rights_documents === 'missing';
    var substantialUncertainty = missing.length >= 3 || uncertain.length >= 3;
    var state = 'ready_to_review';

    if (formalPurpose || complexSite) {
      state = 'professional_scope';
    } else if (siteConditionPurpose && !sitePhotosReady) {
      state = 'site_check_likely';
    } else if (criticalEvidenceGap || substantialUncertainty) {
      state = 'needs_evidence';
    }

    return {
      state: state,
      purpose: purpose,
      siteType: siteType,
      available: available,
      uncertain: uncertain,
      missing: missing,
      recommendedPath: STATE_PATHS[state] || 'complete_evidence',
    };
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function renderList(root, selector, keys, labels, emptyLabel) {
    var list = root.querySelector(selector);
    if (!list) return;
    list.textContent = '';

    if (!keys.length) {
      var empty = document.createElement('li');
      empty.textContent = emptyLabel || '—';
      list.appendChild(empty);
      return;
    }

    keys.forEach(function (key) {
      var item = document.createElement('li');
      item.textContent = labels[key] || key;
      list.appendChild(item);
    });
  }

  function render(root, form, result) {
    var panel = root.querySelector('[data-spatial-precheck-result]');
    if (!panel) return;

    var localizedCopy = getCopy(root);
    var stateCopy =
      localizedCopy &&
      localizedCopy.states &&
      (localizedCopy.states[result.state] || localizedCopy.states.needs_evidence);

    if (!stateCopy) {
      if (form.matches('[data-gse-uav-wizard]'))
        uavStatus(root, true, 'data-uav-diagnosis-error-label');
      return false;
    }

    var evidenceLabels = getEvidenceLabels(form);
    panel.setAttribute('data-readiness-state', result.state);

    setText(panel, '[data-spatial-precheck-state]', stateCopy.badge);
    setText(panel, '[data-spatial-precheck-heading]', stateCopy.heading);
    setText(panel, '[data-spatial-precheck-summary]', stateCopy.summary);
    if (typeof result.score === 'number') {
      setText(panel, '[data-spatial-precheck-score]', String(result.score));
      var recommendationKeys = Array.isArray(result.recommendations) ? result.recommendations : [];
      var recommendationText = recommendationKeys.length
        ? recommendationKeys
            .map(function (key) {
              return evidenceLabels[key] || key.replace(/_/g, ' ');
            })
            .join(' · ')
        : localizedCopy.emptyList;
      setText(panel, '[data-spatial-precheck-recommendation]', recommendationText);
    }
    setText(panel, '[data-spatial-precheck-available-count]', String(result.available.length));
    setText(panel, '[data-spatial-precheck-uncertain-count]', String(result.uncertain.length));
    setText(panel, '[data-spatial-precheck-missing-count]', String(result.missing.length));

    renderList(
      panel,
      '[data-spatial-precheck-available]',
      result.available,
      evidenceLabels,
      localizedCopy.emptyList
    );
    renderList(
      panel,
      '[data-spatial-precheck-uncertain]',
      result.uncertain,
      evidenceLabels,
      localizedCopy.emptyList
    );
    renderList(
      panel,
      '[data-spatial-precheck-missing]',
      result.missing,
      evidenceLabels,
      localizedCopy.emptyList
    );

    setText(panel, '[data-spatial-precheck-next-label]', stateCopy.nextLabel);
    setText(panel, '[data-spatial-precheck-next-copy]', stateCopy.nextCopy);

    var nextAction = panel.querySelector('[data-spatial-precheck-next-action]');
    if (nextAction) {
      nextAction.textContent = stateCopy.actionLabel;
      var needsProfessional = PROFESSIONAL_STATES[result.state] === true;
      nextAction.setAttribute('data-spatial-precheck-return', needsProfessional ? 'false' : 'true');
      var owner = root.closest('[data-spatial-precheck-entry]');
      var returnAnchor = owner && owner.id ? '#' + owner.id : '#spatial-survey-precheck';

      if (needsProfessional) {
        nextAction.href = root.getAttribute('data-professional-review-url') || returnAnchor;
      } else {
        nextAction.href = returnAnchor;
      }
    }

    panel.hidden = false;
    root.__gseLastResult = result;

    if (form.matches('[data-gse-uav-wizard]')) {
      form.hidden = true;
      var progress = root.querySelector('[data-gse-wizard-progress]');
      if (progress) progress.hidden = true;
    }

    var heading = panel.querySelector('[data-spatial-precheck-heading]');
    if (heading) heading.focus({ preventScroll: true });
    panel.scrollIntoView({
      block: 'nearest',
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
    return true;
  }

  function dispatchReviewed(result) {
    window.dispatchEvent(
      new CustomEvent('gcity:spatial-precheck-reviewed', {
        detail: {
          contractVersion:
            result && typeof result.score === 'number'
              ? 'uav-readiness-v1'
              : 'spatial-readiness-v2',
          readinessState: result.state,
          readinessScore: typeof result.score === 'number' ? result.score : null,
          purpose: result.purpose,
          siteType: result.siteType,
          availableEvidence: result.available.slice(),
          uncertainEvidence: result.uncertain.slice(),
          missingEvidence: result.missing.slice(),
          recommendedPath: result.recommendedPath,
          apiTriggered: false,
          persisted: false,
          formalDelivery: false,
        },
      })
    );
  }

  function reviewAndRender(root, form) {
    if (!root || !form) return null;
    var step = form.matches('[data-gse-uav-wizard]')
      ? Number(form.dataset.gseWizardStep || '1')
      : 0;

    if (form.matches('[data-gse-uav-wizard]')) {
      if (!validateWizardStep(form, step)) return null;
    } else if (!form.reportValidity()) {
      return null;
    }

    try {
      var result = readiness(form);
      var rendered = render(root, form, result);
      if (!rendered && form.matches('[data-gse-uav-wizard]')) return null;
      dispatchReviewed(result);
      return result;
    } catch (error) {
      if (!form.matches('[data-gse-uav-wizard]')) throw error;
      uavStatus(root, true, 'data-uav-diagnosis-error-label');
      return null;
    }
  }

  function purposeDisplayLabel(form) {
    var checked = form.querySelector('input[name="purpose"]:checked');
    var card = checked && checked.closest('.gse-choice');
    var label = card && card.querySelector('strong');
    return label ? clean(label.textContent) : getPurpose(form);
  }

  function opaqueRecordId() {
    var random = '';
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        random = window.crypto
          .randomUUID()
          .replace(/[^A-Za-z0-9]/g, '')
          .slice(0, 18);
      }
    } catch (_error) {}
    if (!random) random = Math.random().toString(36).slice(2, 14);
    return 'uav-precheck-' + Date.now().toString(36) + '-' + random;
  }

  function machineEvidence(result) {
    var evidence = (result && result.evidence) || {};
    return Object.keys(evidence)
      .map(function (key) {
        return key + ':' + evidence[key];
      })
      .join('|');
  }

  function resultPayload(root, form, result) {
    if (!root || !form || !result || typeof result.score !== 'number') return null;

    var labels = getEvidenceLabels(form);
    var recommendations = (result.recommendations || []).map(function (key) {
      return labels[key] || key.replace(/_/g, ' ');
    });

    return {
      contract_version: 'uav-readiness-v1',
      record_id: clean(form.dataset.gsePrecheckRecordId) || opaqueRecordId(),
      product_handle:
        clean(root.getAttribute('data-gse-product-handle')) || 'uav-oblique-3d-modeling',
      precheck_type: clean(root.getAttribute('data-gse-precheck-type')) || 'uav-3d',
      precheck_version: 'uav-readiness-v1',
      precheck_score: result.score,
      precheck_purpose: result.purpose,
      precheck_purpose_label: purposeDisplayLabel(form),
      precheck_evidence: machineEvidence(result),
      precheck_recommendations: recommendations.join('|'),
      service_lane:
        clean(root.getAttribute('data-gse-service-lane')) || 'infrastructure-engineering',
      business_need:
        clean(root.getAttribute('data-gse-business-need')) || 'low-altitude-scenario-check',
      source: clean(root.getAttribute('data-gse-source')) || 'uav-precheck',
      component_id: clean(root.getAttribute('data-gse-component-id')),
      created_at: Date.now(),
    };
  }

  function uavStorage(name) {
    try {
      return window[name];
    } catch (_error) {
      return null;
    }
  }

  function uavStatus(root, failed, errorLabel) {
    var status = root.querySelector('[data-uav-precheck-save-status]');
    if (!status) return;
    status.setAttribute('role', failed ? 'alert' : 'status');
    status.setAttribute('aria-live', failed ? 'assertive' : 'polite');
    status.setAttribute('data-state', failed ? 'error' : 'saved');
    status.textContent = root.getAttribute(
      failed ? errorLabel || 'data-uav-storage-error-label' : 'data-uav-saved-label'
    );
    if (failed) status.focus({ preventScroll: true });
  }

  function readJson(storage, key, fallback) {
    try {
      var raw = storage && storage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (_error) {
      return fallback;
    }
  }

  function writeJson(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_error) {
      return false;
    }
  }

  function saveUavResult(root, form, result) {
    var payload = resultPayload(root, form, result);
    if (!payload) return null;

    var rows = readJson(uavStorage('localStorage'), UAV_RESULT_STORAGE_KEY, []);
    if (!Array.isArray(rows)) rows = [];

    rows = [payload]
      .concat(
        rows.filter(function (row) {
          return row && row.record_id !== payload.record_id;
        })
      )
      .slice(0, UAV_RESULT_LIMIT);

    var saved = writeJson(uavStorage('localStorage'), UAV_RESULT_STORAGE_KEY, rows);
    if (!saved) {
      root.removeAttribute('data-uav-precheck-saved');
      uavStatus(root, true);
      return null;
    }

    form.dataset.gsePrecheckRecordId = payload.record_id;
    root.setAttribute('data-uav-precheck-saved', 'true');

    uavStatus(root, false);

    return payload;
  }

  function continueToGCityBrief(root, form, result) {
    var payload = resultPayload(root, form, result);
    if (!payload) return;

    form.dataset.gsePrecheckRecordId = payload.record_id;

    if (!writeJson(uavStorage('sessionStorage'), UAV_HANDOFF_STORAGE_KEY, payload)) {
      uavStatus(root, true);
      return;
    }

    var base =
      root.getAttribute('data-gcity-brief-url') ||
      '/pages/review?source=uav-precheck&intent=review-brief#gcp-brief-form';
    var url = new URL(base, window.location.origin);
    url.searchParams.set('source', payload.source || 'uav-precheck');
    url.searchParams.set('intent', 'review-brief');
    url.searchParams.set('service_lane', payload.service_lane);
    url.searchParams.set('precheck', payload.precheck_type || 'uav-3d');
    window.location.assign(url.pathname + url.search + url.hash);
  }

  function focusDialogStart(root) {
    if (!(root instanceof HTMLElement)) return;
    var target = root.querySelector('[data-spatial-precheck-initial-focus]');
    if (!target || typeof target.focus !== 'function') return;

    window.requestAnimationFrame(function () {
      target.focus({ preventScroll: true });
    });
  }

  function openDialog(root, opener) {
    if (!root || typeof root.showModal !== 'function') return;
    root.__gseLastOpener = opener || null;
    if (!root.open) root.showModal();
    focusDialogStart(root);
  }

  function bindDialog(root, opener) {
    if (!root || root.dataset.spatialPrecheckReady === 'true') return;
    root.dataset.spatialPrecheckReady = 'true';

    var form = root.querySelector('[data-spatial-precheck-form]');
    var closeButton = root.querySelector('[data-spatial-precheck-close]');

    if (opener) {
      opener.addEventListener('click', function () {
        openDialog(root, opener);
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        if (root.open) root.close();
      });
    }

    root.addEventListener('click', function (event) {
      if (event.target === root && root.open) root.close();

      var saveAction = event.target.closest('[data-uav-precheck-save]');
      if (saveAction && form) {
        event.preventDefault();
        saveUavResult(root, form, root.__gseLastResult);
        return;
      }

      var continueAction = event.target.closest('[data-uav-precheck-continue]');
      if (continueAction && form) {
        event.preventDefault();
        continueToGCityBrief(root, form, root.__gseLastResult);
        return;
      }

      var returnAction = event.target.closest(
        '[data-spatial-precheck-next-action][data-spatial-precheck-return="true"]'
      );
      if (returnAction && form) {
        event.preventDefault();

        var resultPanel = root.querySelector('[data-spatial-precheck-result]');
        if (resultPanel) resultPanel.hidden = true;

        form.hidden = false;
        var progress = root.querySelector('[data-gse-wizard-progress]');
        if (progress) progress.hidden = false;

        if (form.matches('[data-gse-uav-wizard]')) {
          setWizardStep(form, 2);
        } else {
          var firstField = form.querySelector('input[name="purpose"], input, select, textarea');
          if (firstField) {
            firstField.focus({ preventScroll: true });
            firstField.scrollIntoView({
              block: 'center',
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth',
            });
          }
        }
      }
    });

    root.addEventListener('close', function () {
      var target = root.__gseLastOpener || opener;
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    });

    if (!form) return;

    bindWizard(root, form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      reviewAndRender(root, form);
    });
  }

  function findDialogForExternalOpener(opener) {
    var requested =
      clean(opener.getAttribute('data-spatial-precheck-target')) ||
      clean(opener.getAttribute('data-spatial-precheck-external-open'));

    if (requested === 'true') requested = '';

    if (requested) {
      var entries = Array.prototype.slice.call(
        document.querySelectorAll('[data-spatial-precheck-entry]')
      );

      for (var index = 0; index < entries.length; index += 1) {
        var entry = entries[index];
        var entryDialog = entry.querySelector('[data-spatial-survey-precheck]');
        var componentId = entryDialog && clean(entryDialog.getAttribute('data-gse-component-id'));

        if (
          componentId === requested ||
          clean(entry.id) === requested ||
          (entryDialog && clean(entryDialog.id) === requested)
        ) {
          return entryDialog;
        }
      }

      var byId = document.getElementById(requested);
      if (byId) {
        if (byId.matches('[data-spatial-survey-precheck]')) return byId;
        return byId.querySelector && byId.querySelector('[data-spatial-survey-precheck]');
      }

      return null;
    }

    var dialogs = document.querySelectorAll('[data-spatial-survey-precheck]');
    return dialogs.length === 1 ? dialogs[0] : null;
  }

  function bindExternalOpeners() {
    if (document.documentElement.dataset.gseExternalOpenReady === 'true') return;

    document.documentElement.dataset.gseExternalOpenReady = 'true';

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-spatial-precheck-external-open]');
      if (!opener) return;

      var dialog = findDialogForExternalOpener(opener);
      if (!dialog) return;

      event.preventDefault();
      openDialog(dialog, opener);
    });
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    context.querySelectorAll('[data-spatial-precheck-entry]').forEach(function (entry) {
      if (entry.dataset.spatialPrecheckEntryReady === 'true') return;

      var opener = entry.querySelector('[data-spatial-precheck-open]');
      var dialog = entry.querySelector('[data-spatial-survey-precheck]');
      bindDialog(dialog, opener);
      entry.dataset.spatialPrecheckEntryReady = 'true';
    });

    context.querySelectorAll('[data-spatial-survey-precheck]').forEach(function (dialog) {
      if (dialog.dataset.spatialPrecheckReady === 'true') return;

      var owner = dialog.closest('[data-spatial-precheck-entry]');
      var opener = owner && owner.querySelector('[data-spatial-precheck-open]');
      bindDialog(dialog, opener);
    });

    bindExternalOpeners();
  }

  window[GLOBAL_KEY] = {
    boot: boot,
    openDialog: openDialog,
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
